import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import { autoTranslate } from "@web-monorepo/vite-auto-translate-plugin/runtime";
import { IdeasCloseIcon } from "components/IdeasIcons";

type EditCloseButtonProps = {
  onClick: VoidFunction;
};

function EditCloseButton({ onClick }: EditCloseButtonProps) {
  return (
    <button
      data-name="edit_header:edit_close_button:ideas_close_icon"
      sx={closeButtonStyle}
      onClick={onClick}
      aria-label={autoTranslate("Close edit modal")}
    >
      <IdeasCloseIcon color="dt_content_primary" />
    </button>
  );
}

type ToolkitCreateHeaderProps = {
  close: VoidFunction;
  title?: string;
};

export default function ToolkitCreateHeader({ close, title }: ToolkitCreateHeaderProps) {
  const headerTitle = title || autoTranslate("New");

  return (
    <div sx={{ position: "relative" }}>
      <EditCloseButton onClick={close} />
      <h2 sx={headerStyle}>{headerTitle}</h2>
    </div>
  );
}

const headerFontStyle: ThemeUIStyleObject = {
  lineHeight: "24px",
  verticalAlign: "middle",
  color: "dt_content_primary",
  fontSize: "24px",
};

const headerStyle: ThemeUIStyleObject = {
  ...headerFontStyle,
  textAlign: "center",
  fontWeight: "bold",
};

const closeButtonStyle: ThemeUIStyleObject = {
  ...headerFontStyle,
  position: "absolute",
  left: 0,
  cursor: "pointer",
  background: "none",
  border: "none",
  margin: "0",
  padding: "0",
  fontSize: "35px",
  color: RAW_cssValue("#8c8c8c"),
  backgroundColor: "transparent",
};
